import { useEffect, useState } from "react";
import { GoToSelect } from 'datastake-daf/dist/components';
import { scrollTo } from 'datastake-daf/src/helpers/GoToSelect';
import { monitoringOptions, supplyChainOptions } from './config';
import { tabsTypes } from "../../../../../../../../components/dashboards/components/project-visualisation/conig";

export default function Filters({ activeTab = '', setFilterKey = () => { } }) {
  const [value, setValue] = useState(undefined);
  const options = activeTab === tabsTypes.MONITORING ? monitoringOptions : supplyChainOptions;

  const _onChange = (val) => {
    const _cont = document.querySelector('.main-project-container');
    setValue(val);

    if (_cont) {
      switch (val) {
        case '1a':
        case '2a':
          const _el1 = document.getElementById('1a');
          scrollTo({ _el: _el1, _cont });
          break;
        case '3a':
        case '4a':
          const _el2 = document.getElementById('3a');
          scrollTo({ _el: _el2, _cont });
          break;
        case '5a':
        case '6a':
          const _el3 = document.getElementById('5a');
          scrollTo({ _el: _el3, _cont });
          break;
        case '7a':
        case '8a':
          const _el4 = document.getElementById('7a');
          scrollTo({ _el: _el4, _cont });
          break;
        case '9a':
          const _el9 = document.getElementById('9a');
          scrollTo({ _el: _el9, _cont });
          break;
        case '10a':
        case '11a':
        case '12a':
        case '13a':
          const _el10 = document.getElementById('10a');
          scrollTo({ _el: _el10, _cont });
          break;

        case '1b':
        case '2b':
          const _el2a = document.getElementById('1b');
          scrollTo({ _el: _el2a, _cont });
          break;
        case '3b':
        case '4b':
        case '5b':
        case '6b':
        case '7b':
        case '8b':
          const _el3a = document.getElementById('3b');
          scrollTo({ _el: _el3a, _cont });
          break;
        default:
      }

      setFilterKey(val);
    }
  };

  useEffect(() => {
    setValue(undefined);
  }, [activeTab]);

  return (
    <GoToSelect
      className="mb-6"
      onChange={_onChange}
      options={options}
      setValue={setValue}
      value={value}
    />
  )
}
